import React, { useCallback } from "react";
import { FixedSizeList as List } from "react-window";
import ParameterRow from "./ParameterRow";
import { Box, ListItemButton, ListItemText, Typography } from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const MeteringGroup = ({ group, expanded, toggle, onChange, onFocus, onBlur ,expandedGroups,handleAddFavParam,handleRemoveFavParam,favParamData}) => {
  const itemData = React.useMemo(() => ({
    parameters: group.parameters,
    groupId: group.id,
    onChange,
    onFocus,
    onBlur,
  }), [group.parameters, group.id, onChange, onFocus, onBlur]);

  // Memoized row renderer
  const Row = useCallback(({ index, style, data }) => {
    const param = data.parameters[index];
    return (
      <div style={style} key={param.id}>
        <ParameterRow
          param={param}
          onChange={(value) => data.onChange(data.groupId, param, value)}
          onFocus={data.onFocus}
          onBlur={data.onBlur}
          handleAddFavParam={handleAddFavParam}
          handleRemoveFavParam={handleRemoveFavParam}
          favParamData={favParamData}
        />
      </div>
    );
  }, []);

  return (
    <>
    <Box sx={{marginTop: '5px' }}>
        <Box sx={{ width: '96%' }}>
            <ListItemButton
                onClick={toggle}
                sx={{ pt: 0, pb: 0, marginBottom: '4px', backgroundColor: 'rgba(0, 0, 0, 0.04)', border: '1px solid #EAEAEA', borderRadius: '4px'}}
            >
                <ListItemText 
                    sx={{ marginBottom: '2px', marginTop: '2px' }} 
                    primary={<Typography sx={{ fontSize: '0.85rem' }}>{group.label}</Typography>} 
                />
                    {expanded ? <ExpandLess fontSize='small' /> : <ExpandMore fontSize='small' />}
            </ListItemButton>
            {expanded && (
                <div style={{ marginTop: "10px" }}>
                <List
                    height={287}
                    itemCount={group.parameters.length}
                    itemSize={35}
                   // width="100%"
                    itemData={itemData}
                    className='paramContainerScroll'
                >
                    {Row}
                </List>
                </div>
            )}
        </Box>
    </Box>





    {/* <div style={{ border: "1px solid #ccc", margin: "10px 0", padding: "10px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <strong>{group.label}</strong>
        <button onClick={toggle}>{expanded ? "Collapse" : "Expand"}</button>
      </div>

      {expanded && (
        <div style={{ marginTop: "10px" }}>
          <List
            height={300}
            itemCount={group.parameters.length}
            itemSize={35}
            width="100%"
            itemData={itemData}
          >
            {Row}
          </List>
        </div>
      )}
    </div> */}
    </>
  );
};

export default React.memo(MeteringGroup);
